export interface CategoryItem {
  id: string;
  url: string;
  icon: string;
  labelKey: string;
  image: string;
}

export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const CATEGORIES: CategoryItem[] = [
  {
    id: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    labelKey: "cat.shoes",
    image: "https://readdy.ai/api/search-image?query=Studio%20product%20photograph%20of%20a%20single%20pair%20of%20white%20leather%20sneakers%20with%20terracotta%20orange%20laces%20floating%20above%20a%20soft%20sage%20green%20studio%20backdrop%20with%20a%20gentle%20gradient%20and%20crisp%20soft%20shadows%20modern%20minimal%20ecommerce%20hero%20shot%20clean%20bright%20and%20highly%20detailed&width=600&height=600&seq=cat-shoes&orientation=squarish&nocache=true",
  },
  {
    id: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    labelKey: "cat.hoodies",
    image: "https://readdy.ai/api/search-image?query=Cozy%20folded%20oversized%20oatmeal%20beige%20hoodie%20with%20sage%20green%20drawstrings%20resting%20on%20a%20warm%20terracotta%20linen%20cloth%20with%20soft%20diffused%20daylight%20textured%20fabric%20detail%20and%20airy%20minimalist%20lifestyle%20flat%20lay%20composition&width=600&height=600&seq=cat-hoodies&orientation=squarish&nocache=true",
  },
  {
    id: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    labelKey: "cat.tshirts",
    image: "https://readdy.ai/api/search-image?query=Neatly%20stacked%20pastel%20cotton%20t-shirts%20in%20blush%20pink%20sand%20and%20cream%20tones%20arranged%20on%20a%20light%20warm%20gray%20surface%20top%20down%20view%20with%20soft%20shadows%20minimal%20apparel%20catalog%20clean%20editorial%20styling&width=600&height=600&seq=cat-tshirts&orientation=squarish&nocache=true",
  },
  {
    id: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-windy-line",
    labelKey: "cat.jackets",
    image: "https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20beige%20textured%20plaster%20wall%20with%20soft%20morning%20light%20and%20natural%20fabric%20texture%20minimal%20fashion%20editorial%20styling&width=600&height=600&seq=cat-jackets&orientation=squarish&nocache=true",
  },
  {
    id: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-scissors-line",
    labelKey: "cat.pants",
    image: "https://readdy.ai/api/search-image?query=Rolled%20indigo%20denim%20jeans%20and%20beige%20chino%20shorts%20laid%20flat%20on%20a%20soft%20whitewashed%20wooden%20board%20with%20warm%20sunlight%20and%20crisp%20shadows%20minimal%20fashion%20flat%20lay%20photography&width=600&height=600&seq=cat-pants&orientation=squarish&nocache=true",
  },
  {
    id: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-star-line",
    labelKey: "cat.headwear",
    image: "https://readdy.ai/api/search-image?query=Structured%20beige%20baseball%20cap%20with%20a%20brown%20leather%20strap%20displayed%20on%20a%20small%20sage%20green%20podium%20against%20a%20warm%20cream%20wall%20with%20studio%20product%20lighting%20minimal%20ecommerce%20photography&width=600&height=600&seq=cat-headwear&orientation=squarish&nocache=true",
  },
  {
    id: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-layout-grid-line",
    labelKey: "cat.sets",
    image: "https://readdy.ai/api/search-image?query=Matching%20sage%20green%20tracksuit%20set%20folded%20neatly%20beside%20a%20small%20terracotta%20accessory%20on%20a%20warm%20sand%20linen%20background%20with%20soft%20natural%20window%20light%20minimal%20lifestyle%20flat%20lay&width=600&height=600&seq=cat-sets&orientation=squarish&nocache=true",
  },
  {
    id: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-leaf-line",
    labelKey: "cat.underwear",
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20undergarments%20in%20neutral%20cream%20and%20taupe%20tones%20folded%20into%20a%20small%20tidy%20stack%20on%20a%20light%20blush%20pink%20surface%20with%20gentle%20daylight%20minimal%20intimate%20apparel%20flat%20lay%20clean%20styling&width=600&height=600&seq=cat-underwear&orientation=squarish&nocache=true",
  },
  {
    id: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-run-line",
    labelKey: "cat.jersey",
    image: "https://readdy.ai/api/search-image?query=Athletic%20sports%20jersey%20in%20deep%20forest%20green%20with%20subtle%20mesh%20texture%20hanging%20on%20a%20light%20warm%20gray%20wall%20with%20a%20single%20warm%20accent%20light%20minimal%20sportswear%20editorial%20photography&width=600&height=600&seq=cat-jersey&orientation=squarish&nocache=true",
  },
  {
    id: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-flashlight-line",
    labelKey: "cat.accessories",
    image: "https://readdy.ai/api/search-image?query=Leather%20wristwatch%20with%20silver%20bracelet%20and%20a%20woven%20bracelet%20arranged%20beside%20folded%20sunglasses%20on%20a%20warm%20taupe%20stone%20surface%20with%20soft%20side%20light%20minimal%20accessories%20flat%20lay%20editorial&width=600&height=600&seq=cat-accessories&orientation=squarish&nocache=true",
  },
  {
    id: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    labelKey: "cat.bags",
    image: "https://readdy.ai/api/search-image?query=Cognac%20brown%20leather%20backpack%20standing%20upright%20on%20a%20light%20warm%20gray%20studio%20backdrop%20with%20soft%20diffused%20lighting%20rich%20leather%20texture%20and%20minimal%20product%20photography%20styling&width=600&height=600&seq=cat-bags&orientation=squarish&nocache=true",
  },
  {
    id: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-key-2-line",
    labelKey: "cat.belts",
    image: "https://readdy.ai/api/search-image?query=Coiled%20dark%20brown%20leather%20belt%20with%20a%20polished%20brass%20buckle%20resting%20on%20a%20warm%20cream%20marble%20surface%20with%20a%20soft%20shadow%20minimal%20accessory%20flat%20lay%20photography&width=600&height=600&seq=cat-belts&orientation=squarish&nocache=true",
  },
  {
    id: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-flower-line",
    labelKey: "cat.perfumes",
    image: "https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20with%20a%20gold%20metallic%20cap%20displayed%20on%20a%20soft%20terracotta%20pedestal%20against%20a%20warm%20cream%20gradient%20background%20studio%20product%20lighting%20minimal%20luxury%20fragrance%20photography&width=600&height=600&seq=cat-perfumes&orientation=squarish&nocache=true",
  },
  {
    id: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    labelKey: "cat.other",
    image: "https://readdy.ai/api/search-image?query=Assorted%20small%20fashion%20accessories%20including%20folded%20socks%20a%20scarf%20and%20a%20knit%20beanie%20arranged%20in%20a%20soft%20tidy%20grid%20on%20a%20warm%20beige%20background%20minimal%20flat%20lay%20editorial%20styling&width=600&height=600&seq=cat-other&orientation=squarish&nocache=true",
  },
];